import { Event, Identifiable, List } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { mapError } from "../utils/mapError";

function moveEvent(httpClient: HttpClient) {
  return (
    event: Identifiable<Event>,
    parentList: Identifiable<List>,
    alignDates: boolean,
  ) =>
    httpClient
      .sendHttpRequest<void>({
        endpoint: `/projects/moveElement`,
        method: HttpMethods.POST,
        data: {
          elementUuid: event.uuid,
          projectEntityType: "EVENT",
          targetActivityUuid: parentList.uuid,
          conserveTime: !alignDates,
        },
      })
      .catch((e) => {
        return Promise.reject(
          mapError(e, {
            startDateOutOfBoundProject: "startDateOutOfBoundProject",
            startDateOutOfBound: "startDateOutOfBound",
            endDateOutOfBoundProject: "endDateOutOfBoundProject",
            endDateOutOfBound: "endDateOutOfBound",
          }),
        );
      });
}

export { moveEvent };
